import { useNavigate, useParams } from "react-router-dom";
import { useCancelCheckoutMutation, useSendMessageMutation } from "../../api/hitl-api";
import { MessageCodes } from "../../components/checkout-status";
import { togglePaymentModal } from "../../store/slices/modalsSlice";
import { useAppDispatch } from "../../store";
import { getMainUrl } from "../../shared/consts";

type UseCancelSessionProps = { onStart?: () => void };

export const useCancelSkuInBoxCheckout = (props?: UseCancelSessionProps) => {
  const [cancel, result] = useCancelCheckoutMutation();
  const [sendMessage] = useSendMessageMutation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { key = "", zoneId = "", storeKey = "" } = useParams();

  const cancelSession = () => {
    if (!result.isLoading) {
      props?.onStart?.();
      return cancel(key)
        .unwrap()
        .then(() => {
          dispatch(togglePaymentModal({ open: false, args: null }));
          sendMessage({
            key: key,
            message_codes: [MessageCodes.CheckoutCancel],
          }).unwrap();

          navigate(getMainUrl({ zoneId, storeKey, mode: "sku-in-box" }));
        });
    }
  };

  return [cancelSession, result] as const;
};
